var PageTransition = {

	init: function(){
		
		//console.log("PAGE TRANSITION INIT");

		$(window).bind('beforeunload', function(){
			//console.log('_debug_ : hide body');
			$(".page-transition").removeClass("animated").addClass("hidden").delay("40").removeClass("hidden").addClass("animated visible");
		});

		$(window).on('load', function(){
			//console.log('_debug_ : hide body');
			$(".page-transition").addClass("animated hidden").removeClass("visible");
		});
	},
}

$(document).ready(function(){
	//PageTransition.init();
})